import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const benefitsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-nav4-benefits-modal" */ './Nav4BenefitsModal').then(
			({ Nav4BenefitsModal }) => Nav4BenefitsModal,
		),
	),
	getPreloadProps: ({ onShow }: { onShow(): void }) => {
		return {
			extraProps: { onShow },
		};
	},
});
